import React from "react";
import Images from "../../../assets/images/Images";
import '../GipDownloadStyle.css';
import styled from "styled-components";
import Colors from "../../../assets/colors/Colors";

import { useTranslation } from "react-i18next";


interface ToolTipProps {
    closeToolTip: () => void,
    showToolTip: boolean
}

const FrontCaret = styled.div`
    margin: auto 0;
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 10px solid ${Colors.headerNavigationRed};
    height: 0px;
    cursor: pointer;
    transform: rotate(90deg);
`;

const ToolTipComponent: React.FC<ToolTipProps> = ({showToolTip, closeToolTip}) => {
    const { t } = useTranslation();

    return(
        <div id='toolTipContainer'>
            {
                showToolTip && (
                    <div id="toolTip" style={{ padding: 39 }}>
                        <div style={{color: "white", cursor: 'pointer'}} onClick={closeToolTip}>X</div>
                        <div id='toolTipTitle'>{ t('pdfDownload.tooltip.title') }</div>
                        <div id='toolTipText'>
                            { t('pdfDownload.tooltip.description')  }
                        </div>
                        <div id='toolTipButtonContainer'>
                            <a id='toolTipButton'
                            href='https://www.fundacionmapfre.org/documentacion/publico/i18n/catalogo_imagenes/grupo.cmd?path=1097445'
                            target='_blank'
                            rel="noopener noreferrer"
                            >
                                <div>
                                  { t('pdfDownload.tooltip.button') }
                                </div>
                                <FrontCaret />
                            </a>
                        </div>
                        <div id="tail1" />
                        <div id="tail2" />
                    </div>
                )
            }
        </div>
    )
};

export default ToolTipComponent;
